export default (i18n, messageKey, params) => {
    let result;
    if (messageKey === 'msg.marketSupervision') {
        [result] = params;
    } else {
        const possibleKey = `messages.types.${messageKey.replace('.', '-')}`;
        if (i18n.exists(possibleKey)) {
            result = i18n.t(possibleKey, { id: params[0], name: params[1] || '' });
        } else {
            result = i18n.t('messages.types.unknown-message-key', { key: messageKey });
        }
    }
    return result;
};
